var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIonic = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 256 256",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4e8ef7",
  d: "M235 39q0 8-5 12 25 33 26 77a128 128 0 1 1-51-102q4-5 12-5 17 2 18 18M128 252a124 124 0 0 0 99-198l-10 3a18 18 0 0 1-15-28Q170 5 128 4a124 124 0 0 0 0 248m0-72a52 52 0 1 1 0-104 52 52 0 0 1 0 104"
})));
export default SvgIonic;